import { getExonnApi } from "src/exonn-api/exonn-api.tsx";

import {
  CommentsPanel,
  type CommentsPanelProps,
} from "src/components/Form/panels/CommentsPanel/CommentsPanel.tsx";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import type { NoteResource } from "@exonn/js-sdk";
import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

type SupportedFormData = {
  data: {
    notes: NoteResource[];
  };
};

export const CommentsPanelV2 = ({
  resource: resourceProp,
}: {
  resource?: string;
}) => {
  const formContext = useResourceFormContext();
  const resource = resourceProp ?? formContext.resource;

  const { id } = formContext;
  const data = useResourceFormData() as SupportedFormData | undefined;
  const props: CommentsPanelProps = {
    notes: (data?.data?.notes || []).map((note) => ({
      ...note,
      author: note.user?.name || "",
    })),
    onSave: async (data) => {
      const api = getExonnApi();
      await api.note.addNote(
        {
          id: id!,
          type: resource,
        },
        data,
      );
    },
  };
  return <CommentsPanel {...props} />;
};
